(function() {
  var menu = document.querySelector('.et-mm');
  if (!menu) return;

  var mainPage = menu.querySelector('[data-et-mm-page="main"]');
  var subPages = menu.querySelectorAll('.et-mm__page--sub');
  var openBtns = menu.querySelectorAll('[data-et-mm-open]');
  var backBtns = menu.querySelectorAll('[data-et-mm-back]');
  var closeBtns = menu.querySelectorAll('.et-mm__close');
  var searchBtn = menu.querySelector('.et-mm__search');

  function openSub(index) {
    menu.classList.add('et-mm--sub-open');
    mainPage.classList.add('et-mm--pushed');
    subPages.forEach(function(p) {
      if (p.dataset.etMmSub === index) {
        p.classList.add('et-mm--active');
      } else {
        p.classList.remove('et-mm--active');
      }
    });
  }

  function closeSub() {
    menu.classList.remove('et-mm--sub-open');
    mainPage.classList.remove('et-mm--pushed');
    subPages.forEach(function(p) {
      p.classList.remove('et-mm--active');
    });
  }

  function closeMenu() {
    var toggle = document.querySelector('.mobile-toggle-wrapper');
    if (toggle) {
      toggle.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      setTimeout(function() {
        toggle.removeAttribute('open');
      }, 350);
    }
    closeSub();
  }

  openBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      openSub(btn.dataset.etMmOpen);
    });
  });

  backBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeSub();
    });
  });

  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeMenu();
    });
  });

  document.addEventListener('keyup', function(e) {
    if (e.code && e.code.toUpperCase() === 'ESCAPE') {
      closeMenu();
    }
  });

  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      closeMenu();
    });
  }
})();
